import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import {
  CookbookInputWrapper,
  CookbookInputWrapperProps,
} from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { EMAIL_REGEX } from 'src/utilities/regexPatterns';

export type BaseEmailInputProps = {
  ariaLabel?: string;
} & Pick<
  CookbookInputWrapperProps,
  | 'disabled'
  | 'rules'
  | 'placeholder'
  | 'label'
  | 'name'
  | 'id'
  | 'suffixDecorator'
>;

export const BaseEmailInput: React.FC<BaseEmailInputProps> = ({
  name,
  id,
  label = 'Email',
  placeholder = 'e.g. john@company.com',
  rules = {},
  ariaLabel,
  ...props
}) => {
  const { errors, control } = useFormContext();

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      type="email"
      control={control}
      error={errors[name]}
      {...(ariaLabel && { 'aria-label': ariaLabel })}
      inputSize="medium"
      blockWidth
      label={label}
      placeholder={placeholder}
      rules={{
        pattern: {
          value: EMAIL_REGEX,
          message: 'Email is invalid',
        },
        ...rules,
      }}
      {...props}
    />
  );
};
